const IMG = {
  school: 'https://images.pexels.com/photos/18503080/pexels-photo-18503080.jpeg?auto=compress&cs=tinysrgb&w=480',
  villa: 'https://images.unsplash.com/photo-1748063578185-3d68121b11ff?crop=entropy&cs=srgb&fm=jpg&w=480&q=70',
  office: 'https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&w=480&q=70',
  industry: 'https://images.pexels.com/photos/36006588/pexels-photo-36006588.jpeg?auto=compress&cs=tinysrgb&w=480',
  generic: 'https://images.pexels.com/photos/16808496/pexels-photo-16808496.png?auto=compress&cs=tinysrgb&w=480',
};

export const HERO_IMAGE = 'https://images.pexels.com/photos/16808496/pexels-photo-16808496.png?auto=compress&cs=tinysrgb&w=1600';

export const projectImage = (project, summary) => {
  const t = `${summary?.project_type || ''} ${project?.name || ''} ${project?.description || ''}`.toLowerCase();
  if (/skola|förskola|forskola|school/.test(t)) return IMG.school;
  if (/villa|radhus|hus|bostad|fritids/.test(t)) return IMG.villa;
  if (/kontor|office/.test(t)) return IMG.office;
  if (/lager|hall|industri|verkstad/.test(t)) return IMG.industry;
  return IMG.generic;
};

export const projectStatus = (p) => {
  if (p?.status === 'completed') return { label: 'Klar', cls: 'bg-emerald-500/15 text-emerald-600', dot: 'bg-emerald-500' };
  if (p?.setup_status === 'started' || p?.status === 'active') return { label: 'Pågående', cls: 'bg-[#F26B1F]/12 text-[#E05A10]', dot: 'bg-[#F26B1F]' };
  return { label: 'Planering', cls: 'bg-stone-500/12 text-stone-600', dot: 'bg-stone-400' };
};

export const kr = (n) => `${Math.round(n || 0).toLocaleString('sv-SE')} kr`;
export const fmt = (n, d = 0) => (Number(n) || 0).toLocaleString('sv-SE', { maximumFractionDigits: d });
